import { ISalesFunnelStage } from './typings'
import { IOption } from '@user/components/Filters'

export const stagesToIOptions = (stages: ISalesFunnelStage[]): IOption[] =>
  stages.map(
    ({ id, name, salesFunnelName, salesFunnelId }): IOption => ({
      value: id,
      label: `${salesFunnelName} - ${name}`,
      group: salesFunnelName,
      parentId: salesFunnelId,
    }),
  )
